<template>
    <div class="w-full">
        <table class="info-table w-full"
            :class="{changes: changes}"
        >
        <tr v-if="changes">
            <th></th>
            <td class="title-change"><b>Previous Version</b></td>
            <td class="title-change"><b>New Version</b></td>
        </tr>

        <tr v-if="['corporate_person', 'corporate_shareholder'].includes(type)">
            <th>
                Is applicable
            </th>
            <td :class="element.is_relevant.error ? 'border border-red-500' : ''">
                <div class="flex column"
                    :class="changes?.is_relevant?.new != undefined && changes?.is_relevant?.current ? 'current changes' : ''"
                >
                    <div class="flex w-full gap-5 p-20 special-input">
                        <span class="flex ">
                            YES <input 
                            type="radio" 
                            :id="`YES-is_relevant-${element._id}`" 
                            style="margin: 0 5px"
                            :name="`is_relevant-${element._id}`"
                            value="YES" 
                        :disabled="disabled"
                        :checked="getCurrentValue('is_relevant') == 'YES'"
                            @change="handleChange('is_relevant', 'YES')">
                        </span>
                        <span class="flex gap-5 " >
                            NO <input 
                                type="radio" 
                                :id="`NO-is_relevant-${element._id}`" 
                                style="margin: 0 5px"
                                :name="`is_relevant-${element._id}`"
                                :checked="getCurrentValue('is_relevant') == 'NO'"
                                value="NO" 
                                :disabled="disabled"
                                @change="handleChange('is_relevant', 'NO')"
                            >
                        </span>
                    
                    </div>
                    <div v-if="element.is_relevant.error" class="text-red-500">
                        {{ element.is_relevant.error }}
                    </div>
                </div>
            </td>
            <td v-if="changes"
                :class="element.is_relevant.error ? 'border border-red-500' : ''">
                <div class="flex column" 
                    :class="changes.is_relevant !== undefined ? 'new-value changes' : ''"
                    >
                    <div class="flex w-full gap-5 p-20 special-input">
                        <span class="flex ">
                            YES <input 
                            type="radio" 
                            :id="`YES-is_relevant-${element._id}`" 
                            style="margin: 0 5px"
                            :name="`is_relevant-${element._id}`"
                            value="YES" 
                            :disabled="true"
                            :checked="getFieldValue('is_relevant', 'new') == 'YES'"
                            >
                        </span>
                        <span class="flex gap-5 " >
                            NO <input 
                                type="radio" 
                                :id="`NO-is_relevant-${element._id}_`" 
                                style="margin: 0 5px"
                                :name="`is_relevant-${element._id}_`"
                                :checked="getFieldValue('is_relevant', 'new') == 'NO'"
                                value="NO" 
                            :disabled="true"
                            >
                        </span>
                    
                    </div>
                    <div v-if="element.is_relevant.error" class="text-red-500">
                        {{ element.is_relevant.error }}
                    </div>
                </div>
            </td>
        </tr>




        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Company Name</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :disabled="disabled"deleteDueDiligenceElement
                    :value="getCurrentValue('company_name')"
                    key_ref="company_name" 
                    type="text" 
                    :class="{changes: changes?.company_name?.new != undefined && changes?.company_name?.current}"
                    class="current"
                    placeholder="Enter company name" 
                    :error="element?.company_name?.error"
                />
            </td>

            <td v-if="changes">
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :disabled="true"
                    :value="getFieldValue('company_name', 'new')"
                    key_ref="company_name" 
                    type="text" 
                    class="new-value"
                    :class="{changes: changes?.company_name?.new != undefined}"
                    placeholder="Enter company name" 
                    :error="element?.company_name?.error"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>Trading Name (if applicable)</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('trading_name')"
                    :disabled="disabled"
                    key_ref="trading_name" 
                    type="text" 
                    placeholder="Enter trading name" 
                    :error="element?.trading_name?.error"
                    class="current"
                    :class="{changes: changes?.trading_name?.new != undefined && changes?.trading_name?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getFieldValue('trading_name', 'new')"
                    :disabled="true"
                    key_ref="trading_name" 
                    type="text" 
                    placeholder="Enter trading name" 
                    :error="element?.trading_name?.error"
                    class="new-value"
                    :class="{changes: changes?.trading_name?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Registration Number</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('registration_number')"
                    :disabled="disabled"
                    key_ref="registration_number" 
                    type="text" 
                    placeholder="Enter registration number" 
                    :error="element?.registration_number?.error"
                    class="current"
                    :class="{changes: changes?.registration_number?.new != undefined && changes?.registration_number?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :disabled="true"
                    :value="getFieldValue('registration_number', 'new')"
                    type="text" 
                    class="new-value"
                    :class="{changes: changes?.registration_number?.new != undefined}"
                    :error="element?.registration_number?.error"
                />
            </td>
        </tr>
        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Registration Date</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('registration_date')"
                    key_ref="registration_date" 
                    :disabled="disabled"
                    type="date" 
                    placeholder="Select registration date" 
                    :error="element?.registration_date?.error"
                    class="current"
                    :class="{changes: changes?.registration_date?.new != undefined && changes?.registration_date?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getCurrentValue('registration_date')"
                    :disabled="true"
                    type="date" 
                    class="new-value"
                    :class="{changes: changes?.registration_date?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Registration Country</th>
            <td>
                <InpComponent 
                    class="w-full current"
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('registration_country')"
                    key_ref="registration_country" 
                    :disabled="disabled"
                    :options="Utils && Utils.getCountryList()"
                    type="options" 
                    :class="{changes: changes?.registration_country?.new != undefined && changes?.registration_country?.current}"
                    placeholder="Enter registration country" 
                    :error="element?.registration_country?.error"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    class="w-full new-value"
                    :value="getCurrentValue('registration_country')"
                    :disabled="true"
                    :options="Utils && Utils.getCountryList()"
                    type="options" 
                    :class="{changes: changes?.registration_country?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Registered Address</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('registered_address')"
                    key_ref="registered_address" 
                    :disabled="disabled"
                    type="text" 
                    placeholder="Enter registered address" 
                    :error="element?.registered_address?.error"
                    class="current"
                    :class="{changes: changes?.registered_address?.new != undefined && changes?.registered_address?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('registered_address', 'new')"
                    :disabled="true"
                    type="text" 
                    class="new-value"
                    :class="{changes: changes?.registered_address?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Business Address (if different from registered address)</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('business_address')"
                    :disabled="disabled"
                    key_ref="business_address" 
                    type="text" 
                    placeholder="Enter business address" 
                    :error="element?.business_address?.error"
                    class="current"
                    :class="{changes: changes?.business_address?.new != undefined && changes?.business_address?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('business_address', 'new')"
                    :disabled="true"
                    type="text" 
                    class="new-value"
                    :class="{changes: changes?.business_address?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>Tax ID</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('tax_id')"
                    key_ref="tax_id" 
                    :disabled="disabled"
                    type="text" 
                    placeholder="Enter tax ID" 
                    :error="element?.tax_id?.error"
                    class="current"
                    :class="{changes: changes?.tax_id?.new != undefined && changes?.tax_id?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('tax_id', 'new')"
                    :disabled="true"
                    type="text" 
                    class="new-value"
                    :class="{changes: changes?.tax_id?.new != undefined}"
                />
            </td>
        </tr>
        <tr class="empty-row"  v-if="['company'].includes(type)">
            <th></th>
            <td></td>
            <td v-if="changes"></td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>Contact Person Name</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('contact_person_name')"
                    key_ref="contact_person_name" 
                    type="text" 
                    :disabled="disabled"
                    placeholder="Enter contact person name" 
                    :error="element?.contact_person_name?.error"
                    class="current"
                    :class="{changes: changes?.contact_person_name?.new != undefined && changes?.contact_person_name?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('contact_person_name', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.contact_person_name?.new != undefined}"
                />
            </td>
        </tr>

        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Full name
            </th>
            
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('full_name')"
                    key_ref="full_name" 
                    :disabled="disabled"
                    type="email" 
                    placeholder="Full Name" 
                    :error="element?.full_name?.error"
                    class="current"
                    :class="{changes: changes?.full_name?.new != undefined && changes?.full_name?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('full_name', 'new')"
                    type="email" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.full_name?.new != undefined}"
                />
            </td>
        </tr>
    
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Date of birth
            </th>
            
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('date_of_birth')"
                    key_ref="date_of_birth" 
                    type="date" 
                    :disabled="disabled"
                    placeholder="" 
                    :error="element?.date_of_birth?.error"
                    class="current"
                    :class="{changes: changes?.date_of_birth?.new != undefined && changes?.date_of_birth?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('date_of_birth', 'new')"
                    type="date" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.date_of_birth?.new != undefined}"
                />
            </td>
        </tr>

        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Place of birth
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('place_of_birth')"
                    key_ref="place_of_birth" 
                    :options="Utils && Utils.getCountryList()"
                    :disabled="disabled"
                    type="options"
                    placeholder="Curacao" 
                    :error="element?.place_of_birth?.error"
                    class="current"
                    :class="{changes: changes?.place_of_birth?.new != undefined && changes?.place_of_birth?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('place_of_birth', 'new')"
                    type="options" 
                    :disabled="true"
                    placeholder="Curacao" 
                    class="new-value"
                    :class="{changes: changes?.place_of_birth?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Residential address
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('residential_address')"
                    :disabled="disabled"
                    key_ref="residential_address" 
                    type="text"
                    placeholder="Full Name" 
                    :error="element?.residential_address?.error"
                    class="current"
                    :class="{changes: changes?.residential_address?.new != undefined && changes?.residential_address?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('residential_address', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.residential_address?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Identity document type
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('identity_document')"
                    key_ref="identity_document" 
                    :disabled="disabled"
                    type="options"
                    :options="[{value: 'id_card', text: 'ID Card'}, {value: 'driver_license', text: 'Driver License'}]"
                    :error="element?.identity_document?.error"
                    class="current"
                    :class="{changes: changes?.identity_document?.new != undefined && changes?.identity_document?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('identity_document', 'new')"
                    type="options" 
                    :disabled="true"
                    :options="[{value: 'id_card', text: 'ID Card'}, {value: 'driver_license', text: 'Driver License'}]"
                    class="new-value"
                    :class="{changes: changes?.identity_document?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Identity document number
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('identity_document_number')"
                    :disabled="disabled"
                    key_ref="identity_document_number" 
                    type="text"
                    :error="element?.identity_document_number?.error"
                    class="current"
                    :class="{changes: changes?.identity_document_number?.new != undefined && changes?.identity_document_number?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('identity_document_number', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.identity_document_number?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Date of issue
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('date_of_issue')"
                    :disabled="disabled"
                    key_ref="date_of_issue" 
                    type="date"
                    :error="element?.date_of_issue?.error"
                    class="current"
                    :class="{changes: changes?.date_of_issue?.new != undefined && changes?.date_of_issue?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('date_of_issue', 'new')"
                    type="date" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.date_of_issue?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Date of expiry
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('date_of_expiry')"
                    :disabled="disabled"
                    key_ref="date_of_expiry" 
                    type="date"
                    :error="element?.date_of_expiry?.error"
                    class="current"
                    :class="{changes: changes?.date_of_expiry?.new != undefined && changes?.date_of_expiry?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('date_of_expiry', 'new')"
                    type="date" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.date_of_expiry?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Issuing authority
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('issuing_authority')"
                    :disabled="disabled"
                    key_ref="issuing_authority" 
                    type="text"
                    :error="element?.issuing_authority?.error"
                    class="current"
                    :class="{changes: changes?.issuing_authority?.new != undefined && changes?.issuing_authority?.current}"
                />
            </td>

            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('issuing_authority', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.issuing_authority?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Issuing state
            </th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('issuing_state')"
                    :disabled="disabled"
                    key_ref="issuing_state" 
                    type="text"
                    placeholder="Curacao"
                    :error="element?.issuing_state?.error"
                    class="current"
                    :class="{changes: changes?.issuing_state?.new != undefined && changes?.issuing_state?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('issuing_state', 'new')"
                    type="text" 
                    :disabled="true"
                    placeholder="Curacao"
                    class="new-value"
                    :class="{changes: changes?.issuing_state?.new != undefined}"
                />
            </td>
        </tr>
      
    
        <tr v-if="['shareholder', 'corporate_shareholder', 'beneficiary'].includes(type)">
            <th>
                Amount of shares holding (%)
            </th>
            
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('amount_of_shares_holding')"
                    key_ref="amount_of_shares_holding" 
                    :disabled="disabled"
                    type="number" 
                    placeholder="20%" 
                    :error="element?.amount_of_shares_holding?.error"
                    class="current"
                    :class="{changes: changes?.amount_of_shares_holding?.new != undefined && changes?.amount_of_shares_holding?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('amount_of_shares_holding', 'new')"
                    type="number" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.amount_of_shares_holding?.new != undefined}"
                />
            </td>
        </tr>
        
        <tr v-if="['director', 'shareholder', 'beneficiary', 'corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Contact E-mail Address</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('contact_email_address')"
                    key_ref="contact_email_address" 
                    :disabled="disabled"
                    type="email" 
                    placeholder="Enter contact email" 
                    :error="element?.contact_email_address?.error"
                    class="current"
                    :class="{changes: changes?.contact_email_address?.new != undefined && changes?.contact_email_address?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('contact_email_address', 'new')"
                    type="email" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.contact_email_address?.new != undefined}"
                />
            </td>
        </tr>

        <tr v-if="['director', 'shareholder', 'beneficiary', 'corporate_person', 'corporate_shareholder', 'company'].includes(type)">
            <th>Contact Phone Number</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('contact_phone_number')"
                    key_ref="contact_phone_number" 
                    :disabled="disabled"
                    type="tel" 
                    placeholder="Enter contact phone number" 
                    :error="element?.contact_phone_number?.error"
                    class="current"
                    :class="{changes: changes?.contact_phone_number?.new != undefined && changes?.contact_phone_number?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('contact_phone_number', 'new')"
                    type="tel" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.contact_phone_number?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['shareholder', 'director', 'beneficiary'].includes(type)">
            <th>
                Politically Exposed Person (PEP)
            </th>
            <td :class="element.politically_exposed_person.error ? 'border border-red-500' : ''">
                <div class="flex column"
                    :class="changes?.politically_exposed_person?.new != undefined && changes?.politically_exposed_person?.current ? 'current changes' : ''"

                >
                    <div class="flex w-full gap-5 p-20 special-input">
                        <span class="flex ">
                            YES <input 
                            type="radio" 
                            :id="`YES-politically_exposed_person-${element._id}`" 
                            style="margin: 0 5px"
                            :name="`politically_exposed_person-${element._id}`"
                            value="YES" 
                        :disabled="disabled"
                        :checked="getCurrentValue('politically_exposed_person') == 'YES'"
                            @change="handleChange('politically_exposed_person', 'YES')">
                        </span>
                        <span class="flex gap-5 " >
                            NO <input 
                                type="radio" 
                                :id="`NO-politically_exposed_person-${element._id}`" 
                                style="margin: 0 5px"
                                :name="`politically_exposed_person-${element._id}`"
                                :checked="getCurrentValue('politically_exposed_person') == 'NO'"
                                value="NO" 
                                :disabled="disabled"
                                @change="handleChange('politically_exposed_person', 'NO')"
                            >
                        </span>
                    
                    </div>
                    <div v-if="element.politically_exposed_person.error" class="text-red-500">
                        {{ element.politically_exposed_person.error }}
                    </div>
                </div>
            </td>
            <td v-if="changes"
                :class="element.politically_exposed_person.error ? 'border border-red-500' : ''">
                <div class="flex column" 
                    :class="changes.politically_exposed_person !== undefined ? 'new-value changes' : ''"
                    >
                    <div class="flex w-full gap-5 p-20 special-input">
                        <span class="flex ">
                            YES <input 
                            type="radio" 
                            :id="`YES-politically_exposed_person-${element._id}`" 
                            style="margin: 0 5px"
                            :name="`politically_exposed_person-${element._id}`"
                            value="YES" 
                            :disabled="true"
                            :checked="getFieldValue('politically_exposed_person', 'new') == 'YES'"
                            >
                        </span>
                        <span class="flex gap-5 " >
                            NO <input 
                                type="radio" 
                                :id="`NO-politically_exposed_person-${element._id}_`" 
                                style="margin: 0 5px"
                                :name="`politically_exposed_person-${element._id}_`"
                                :checked="getFieldValue('politically_exposed_person', 'new') == 'NO'"
                                value="NO" 
                            :disabled="true"
                            >
                        </span>
                    
                    </div>
                    <div v-if="element.politically_exposed_person.error" class="text-red-500">
                        {{ element.politically_exposed_person.error }}
                    </div>
                </div>
            </td>



        </tr>
        <tr class="empty-row" v-if="['company'].includes(type)">
            <th></th>
            <td></td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>Website URL(s)</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('website_urls')"
                    key_ref="website_urls" 
                    :disabled="disabled"
                    type="text" 
                    placeholder="Enter website URL" 
                    :error="element?.website_urls?.error"
                    class="current"
                    :class="{changes: changes?.website_urls?.new != undefined && changes?.website_urls?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('website_urls', 'new')"
                    key_ref="website_urls" 
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.website_urls?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>License Issuing Authority</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('license_issuing_authority')"
                    key_ref="license_issuing_authority" 
                    type="text" 
                    :disabled="disabled"
                    placeholder="Enter license issuing authority" 
                    :error="element?.license_issuing_authority?.error"
                    class="current"
                    :class="{changes: changes?.license_issuing_authority?.new != undefined && changes?.license_issuing_authority?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('license_issuing_authority', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.license_issuing_authority?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>License Type</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('license_type')"
                    key_ref="license_type" 
                    type="text" 
                    :disabled="disabled"
                    placeholder="Enter license type" 
                    :error="element?.license_type?.error"
                    class="current"
                    :class="{changes: changes?.license_type?.new != undefined && changes?.license_type?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('license_type', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.license_type?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>License Number</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('license_number')"
                    key_ref="license_number" 
                    type="text" 
                    :disabled="disabled"
                    placeholder="Enter license number" 
                    :error="element?.license_number?.error"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('license_number', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.license_number?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>License Date of Issue</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('license_date_of_issue')"
                    key_ref="license_date_of_issue" 
                    type="date" 
                    :disabled="disabled"
                    placeholder="Select license date of issue" 
                    :error="element?.license_date_of_issue?.error"
                    class="current"
                    :class="{changes: changes?.license_date_of_issue?.new != undefined && changes?.license_date_of_issue?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('license_date_of_issue', 'new')"
                    type="date" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.license_date_of_issue?.new != undefined}"
                />
            </td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>License Expiry Date</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('license_expiry_date')"
                    key_ref="license_expiry_date" 
                    type="date" 
                    :disabled="disabled"
                    placeholder="Select license expiry date" 
                    :error="element?.license_expiry_date?.error"
                    class="current"
                    :class="{changes: changes?.license_expiry_date?.new != undefined && changes?.license_expiry_date?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('license_expiry_date', 'new')"
                    type="date" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.license_expiry_date?.new != undefined}"
                />
            </td>
        </tr>
        <tr class="empty-row" v-if="['company'].includes(type)">
            <th></th>
            <td></td>
            <td v-if="changes"></td>
        </tr>
        <tr v-if="['company'].includes(type)">
            <th>Targeted Countries</th>
            <td>
                <InpComponent 
                    @inputChange="inputChangeFunc"
                    :value="getCurrentValue('targeted_countries')"
                    key_ref="targeted_countries" 
                    type="text" 
                    placeholder="Enter targeted countries" 
                    :disabled="disabled"
                    :error="element?.targeted_countries?.error"
                    class="current"
                    :class="{changes: changes?.targeted_countries?.new != undefined && changes?.targeted_countries?.current}"
                />
            </td>
            <td v-if="changes">
                <InpComponent 
                    :value="getFieldValue('targeted_countries', 'new')"
                    type="text" 
                    :disabled="true"
                    class="new-value"
                    :class="{changes: changes?.targeted_countries?.new != undefined}"
                />
            </td>
        </tr>
    </table>
   
   </div>
</template>


<script setup>

    import { ref, computed, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import { useStore } from 'vuex';
    import InpComponent from '@/components/InpComponent.vue';
    import Utils from '@/utils';
    const props = defineProps([
        'id', 
        'changes',
        'sourceObjectState',
        'reviewMode'
    ]);
    const store = useStore();

    const disabled = computed(() => {
        if (props.changes) {
            return true;
        }
        if (props.reviewMode) {
            return true;
        }
        if (!store.state.dueDiligenceRecord) {
            return true;
        }
        return (
        !(
            !(store.state.dueDiligenceRecord.status == 'approved' || store.state.user) || (store.state.editDueDiligence && store.state.user)
        )   
    )})
    function getCurrentValue(field){
        if (!props.changes) {
            return element.value[field].new_value || element.value[field].value;
        }
        return props.sourceObjectState[field] 
    }
    const route = useRoute();
    const elementId = ref(props.id);

    const element = computed(() => {
        console.log('elementId.value', store.state.dueDiligenceElements);
        return store.state.dueDiligenceElements.find((el) => el._id == elementId.value);
    });
    const type = computed(() => {
        return element.value.type.value;
    });

    const types = [
        'company', 
        'corporate_person', 
        'shareholder', 
        'director', 
        'beneficiary',
        'corporate_shareholder', 

    ];
    function handleChange(field, event) {
        store.commit('updateDueDiligenceElement', {
            id: props.id,
            updates: {
                [field]: event
            }
        })
    }


    function inputChangeFunc(event) {
        const event_type = event[0];
        const event_value = event[1];
        store.commit('updateDueDiligenceElement',{
            id: props.id,
            updates: {
                [`${event_type}`]: event_value,
            }
        })
    }
    function getFieldValue(field, state) {
        if (!props.changes) {
            return element.value[field].value;
        }
        if (
            state == 'current' && 
            props.changes[field] && 
            !props.changes[field].current && 
            props.changes[field].new
        ) {
            return null;
        }
        if (props.changes[field] && props.changes[field][state]) {
            return props.changes[field][state];
        }
        return element.value[field].value;
    }
    onMounted(() => {
    });

</script>

<style scoped lang="scss">

    .main-container {
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
    }
    .table-wrapper {
        width: 100%;
        max-width: 1350px;
    }
    .empty-row {
        height: 40px;
        background-color: transparent;
    }
    .section {
        align-items: flex-start;
        background: white;
        border-radius: 8px;
        padding: 20px;
        border: 1px solid var(--border-color);

    }
    .special-input {
        padding: 0;
        margin: 0px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        gap: 10px;
        padding-left: 80px;
        box-sizing: border-box;

    }
    .section-header {
        font-size: 16px;
        font-weight: 600;
        padding-left: 15px;
        margin-bottom: 10px;
        text-align: left;
    }
    .info-table {
        text-align: left;
        width: 100%;
        max-width: 1350px;
        tr {
            td, th {
                padding: 0px;
            }
            th {
                vertical-align: top;
                padding-left: 5px;
                width: 40%;
            }
            td {
                &:deep(.styled-input) {
                    margin-bottom: 0;
                }
            }
        }
    }
    th, td {
        border-bottom: 1px solid var(--border-color);
    }

    input[type="radio"] {
        margin: 0 5px;
        width: 20px;
        height: 25px;
        margin: auto;
        border: unset;
        outline: unset;
    }
    .border {
        border: 1px solid var(--border-color);
    }
    .border-red-500[class] {
        border-color: red;
    }
    .text-red-500 {
        color: red;
        font-size: 10px;
        padding-left: 10px;
    }
    .new-value.changes {
        background: #DEF7EC;
    }
    .current.changes {
        background: #FDE8E8;
    }
    .changes {
        tr > th {
            width: 20%;
        }

        tr > td {
            width: 40%;
        }
    }
    .title-change[class] {
        padding: 10px
    }


</style>